import { createFileRoute,Outlet } from '@tanstack/react-router'
import { z } from 'zod'
import { requireAuth } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'

const searchSchema = z.object({
  page: z.number().catch(1),
  limit: z.number().int().min(1).max(100).catch(20),
  search: z.string().catch(''),
  status: z.string().catch(''),
})

export const Route = createFileRoute('/_dashboard/sales')({
  beforeLoad: requireAuth(),
  validateSearch: searchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: SalesLayout,
})

function SalesLayout() {
  return <Outlet />
}

export { SalesPage } from '@/features/pos/sales-page'
